import { createSlice, PayloadAction, Dispatch } from "@reduxjs/toolkit";
import { AgentService } from "app/services";

export type SubAgentRow = {
  id: string;
  fullName: string;
  email: string;
  phoneNumber: string;
  status: boolean;
};

interface SubAgentsState {
  loading: boolean;
  rows: SubAgentRow[];
}

const initialState: SubAgentsState = {
  loading: false,
  rows: [],
};

const slice = createSlice({
  name: "subAgents",
  initialState,
  reducers: {
    start: (state) => {
      state.loading = true;
    },
    set: (state, action: PayloadAction<SubAgentRow[]>) => {
      state.rows = action.payload;
      state.loading = false;
    },
    fail: (state) => {
      state.loading = false;
    },
  },
});

export const { start, set, fail } = slice.actions;
export default slice.reducer;

export const getSubAgents =
  (agentId: string) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(start());

      // AgentService.getSubAgents returns the body already (response.data)
      const body = await AgentService.getSubAgents(agentId);

      // handle both cases: paginated {content: []} OR plain []
      const items = Array.isArray(body)
        ? body
        : body?.content?.content ?? body?.content ?? [];


      const rows: SubAgentRow[] = items.map((a: any) => ({
        id: a.id,
        fullName: a.fullName ?? "",
        email: a.email ?? a.email1 ?? a.contactEmail ?? "",
        phoneNumber: a.phoneNumber ?? "",
        // adjust to your real field name (examples below)
        status: a.status ?? a.active ?? a.enabled ?? a.isActive ?? false,
      }));

      dispatch(set(rows));
      } catch (e) {
      dispatch(fail());
    }
  };
